import React, { useLayoutEffect, useRef, useState } from "react";
import { withRouter } from "../../app-services/lib/router-compat";
import Footer from "../../components/layouts/footer/Footer";
import Announcement from "../../components/layouts/announcement/AnnouncementBar";
import Header from "../../components/layouts/header/Header";

import HandPrint from "../../components/HandPrint/HandPrint";
import PictureBook from "../../components/PictureBook/PictureBook";
import ChapterBook from "../../components/SelfPublish/SelfPublish";
import Thisisyourworld from "../../components/thisisyourworld/Worldbook";
import ThumbPrint from "../../components/ThumbPrint/ThumbPrint";
import Customtext from "../../components/CustomText/CustomText";
import CustomCharacterBook from "../../components/custom-character/CustomCharacterBook";

function getBookComponent(name) {
  switch (name) {
    case "chapter-book":
      return ChapterBook;
    case "picture-book":
      return PictureBook;
    case "customcharacter-book":
      return CustomCharacterBook;
    case "world-book":
      return Thisisyourworld;
    case "handprint-book":
      return HandPrint;
    case "thumbprint-book":
      return ThumbPrint;
    case "customtext-book":
      return Customtext;
    default:
      return null;
  }
}

export function BookPage(props) {
  const self = useRef({}).current;
  const params = props.match.params;
  const genpdf = params.genpdf;

  // Keep props on the legacy `self` bag every render (for setStore / $store)
  self.props = props;

  useLayoutEffect(() => {
    initialConstruct.bind(self)("BookPage", props);
  }, []);

  const [CategoryBook] = useState(() => getBookComponent(params.name));

  if (!CategoryBook) {
    return (
      <div>
        <Announcement />
        <Header />
        <div className="container py-5">Book type not found.</div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      {genpdf ? (
        <>
          <CategoryBook genpdf={genpdf} />
        </>
      ) : (
        <>
          <Announcement />
          <Header />
          <CategoryBook genpdf={genpdf} />
          <Footer />
        </>
      )}
    </div>
  );
}

export default connect(withRouter(BookPage));
